import { Palette, createPalette as muiCreatePalette } from '@mildang/mui';

type NestedKeyOf<ObjectType extends object> = {
  [Key in keyof ObjectType & (string | number)]: ObjectType[Key] extends object
    ? `${Key}` | `${Key}.${NestedKeyOf<ObjectType[Key]>}`
    : `${Key}`;
}[keyof ObjectType & (string | number)];

export type ColorKeys = NestedKeyOf<Palette>;

const generatePalette = () =>
  muiCreatePalette({
    // getContrastText: function getContrastText(background) {
    //   return background;
    // },
    stroke: 'rgba(237, 238, 242, 1)',
    snackbar: '#2B2D36',
    activeRating: 'rgba(255, 204, 51, 1)',
    divider: 'rgba(237, 238, 242, 1)',
    primary: {
      dark: 'rgba(30, 32, 36, 1)',
      darkActive: 'rgba(30, 32, 36, 0.80)',
      darkHover: 'rgba(30, 32, 36, 0.90)',
      main: 'rgba(30, 32, 36, 1)',
      stroke: 'rgba(226, 228, 234, 1)',
      strokeHover: 'rgba(203, 207, 216, 1)',
      lightHover: 'rgba(250, 251, 252, 1)',
      lightActive: 'rgba(237, 238, 242, 1)',
      light: 'rgba(255, 255, 255, 1)',
      contrastText: 'rgba(255, 255, 255, 1)',
    },
    secondary: {
      dark: '#1c7d55',
      darkActive: '#1f895d',
      darkHover: '#239565',
      main: '#2aa270',
      stroke: '#ace2cb',
      strokeHover: '#90dabb',
      lightActive: '#e1f4ec',
      lightHover: '#effaf5',
      light: '#f6fcf9',
      contrastText: 'rgba(255, 255, 255, 1)',
    },
    error: {
      dark: '#c8323e',
      darkActive: '#e13745',
      darkHover: '#ef4352',
      main: '#fb515f',
      stroke: '#ffc2c7',
      strokeHover: '#ffa3ab',
      lightHover: '#fff5f6',
      lightActive: '#ffebec',
      light: 'rgba(255, 250, 250, 1)',
      contrastText: 'rgba(255, 255, 255, 1)',
    },
    success: {
      dark: 'rgba(28, 125, 85, 1)',
      darkActive: '#1f895d',
      darkHover: '#239565',
      main: '#2aa270',
      stroke: '#ace2cb',
      strokeHover: '#90dabb',
      lightHover: '#effaf5',
      lightActive: '#e1f4ec',
      light: '#f6fcf9',
      contrastText: 'rgba(255, 255, 255, 1)',
    },
    warning: {
      dark: 'rgba(189, 75, 0, 1)',
      darkActive: 'rgba(209, 84, 0, 1)',
      darkHover: 'rgba(224, 89, 0, 1)',
      main: 'rgba(255, 185, 138, 1)',
      stroke: 'rgba(255, 203, 169, 1)',
      strokeHover: 'rgba(255, 185, 138, 1)',
      lightActive: 'rgba(255, 240, 229, 1)',
      lightHover: 'rgba(255, 246, 240, 1)',
      light: 'rgba(255, 252, 250, 1)',
      contrastText: 'rgba(255, 255, 255, 1)',
    },
    info: {
      dark: 'rgba(0, 105, 224, 1)',
      darkActive: 'rgba(0, 120, 240, 1)',
      darkHover: 'rgba(0, 131, 245, 1)',
      main: 'rgba(0, 145, 255, 1)',
      stroke: 'rgba(173, 220, 255, 1)',
      strokeHover: 'rgba(138, 204, 255, 1)',
      lightActive: 'rgba(228, 243, 255, 1)',
      lightHover: 'rgba(240, 248, 255, 1)',
      light: 'rgba(246, 251, 255, 1)',
      contrastText: 'rgba(255, 255, 255, 1)',
    },
    text: {
      primary: 'rgba(30, 32, 36, 1)',
      secondary: 'rgba(79, 84, 95, 1)',
      tertiary: 'rgba(107, 113, 128, 1)',
    },
    background: {
      primary: 'rgba(255, 255, 255, 1)',
      secondary: 'rgba(250, 251, 252, 1)',
      tertiary: 'rgba(245, 246, 248, 1)',
      paper: 'rgba(255, 255, 255, 1)',
      default: 'rgba(255, 255, 255, 1)',
    },
    common: {
      black: 'rgba(9, 11, 16, 1)',
      white: 'rgba(255, 255, 255, 1)',
    },
    grey: {
      50: 'rgba(250, 251, 252, 1)',
      100: 'rgba(245, 246, 248, 1)',
      200: 'rgba(237, 238, 242, 1)',
      300: 'rgba(226, 228, 234, 1)',
      400: 'rgba(203, 207, 216, 1)',
      500: 'rgba(30, 32, 36, 1)',
      600: 'rgba(107, 113, 128, 1)',
      700: 'rgba(79, 84, 95, 1)',
      800: 'rgba(79, 84, 95, 1)',
      900: 'rgba(30, 32, 36, 1)',
      A100: 'rgba(245, 246, 248, 1)',
      A200: 'rgba(237, 238, 242, 1)',
      A400: 'rgba(203, 207, 216, 1)',
      A700: 'rgba(79, 84, 95, 1)',
    },
  });

export default generatePalette;
